import { displayId, last_name, TABLE_HEADERS } from "../common/statics";
import { useDrawFile } from "../hook/use_draw_file";

const Headers = () => {
    const { sortByTz, sortByName } = useDrawFile();
    const getSortHandler = (header) => {
        if (header === last_name) return sortByName;
        if (header === displayId) return sortByTz;
        return null;
    };

    return (
        <thead>
            <tr>
                {TABLE_HEADERS.map((header) => {
                    const onSort = getSortHandler(header);
                    return (
                        <th scope="col" key={header}>
                            <div style={{ width: '55px', display: 'grid', alignItems: 'center' }}>
                                {onSort && (
                                    <button className="btn" style={{ padding: 0 }}
                                        onClick={() => onSort()}>
                                        <span>⬇️​</span>
                                    </button>
                                )}
                                {header}
                            </div>
                        </th>
                    )
                })}
            </tr>
        </thead>
    )
};

export default Headers;